import { HashLocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})

export class EncrDecrService {
  constructor() { }
  //The set method is use for encrypt the value.
  set(value: any) {
    var key = CryptoJS.enc.Utf8.parse('87GRAFJRPMAMMHSA98765432');
    var iv = CryptoJS.enc.Utf8.parse('87GRAFJRPMAMMHSA');

    //var key = CryptoJS.enc.Utf8.parse('D890ED11B308D656');
    //var iv = CryptoJS.enc.Utf8.parse('4FF28A9F7F9CC37F');

    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(value)), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    ;
    return encrypted.toString();
  }

  //The get method is use for decrypt the value.
  get(value: any) {
    

    var key = CryptoJS.enc.Utf8.parse('87GRAFJRPMAMMHSA98765432');
    var iv = CryptoJS.enc.Utf8.parse('87GRAFJRPMAMMHSA');

    //var key = CryptoJS.enc.Utf8.parse('D890ED11B308D656');
    //var iv = CryptoJS.enc.Utf8.parse('4FF28A9F7F9CC37F');

    var decrypted = CryptoJS.AES.decrypt(value, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  //decryptData1(ciphertextB64: any) {
  //  // Base64 encoded ciphertext, 32 bytes string as key
  //  
  //  var key = CryptoJS.enc.Utf8.parse('87GRAFJRPMAMMHSA98765432');                            // Convert into WordArray (using Utf8)
  //  var iv = CryptoJS.enc.Utf8.parse('87GRAFJRPMAMMHSA');   // Use zero vector as IV
  //  var decrypted = CryptoJS.AES.decrypt(ciphertextB64, key, { iv: iv }); // By default: CBC, PKCS7 
  //  return decrypted.toString(CryptoJS.enc.Utf8);                       // Convert into string (using Utf8)
  //}

  //public callServiceCountry() {
  //  
  //  this.http.get('https://localhost:44367/api/Master/eziPayAfrica/Servicecountry', { responseType: 'text' })
  //    .subscribe(response => {
  //      ////////console.log(response);
  //      ////////console.log(this.encrDecrService.decryptData1(response));

  //    });

  //}

  //public createHeader() {

  //  / Non standard headers, due to cors issue additional headers commented by Nivetha /

  //  const httpOptions = new HttpHeaders({
  //    'Content-Type': 'application/json, text/plain'
  //  });
  //}

  //return this.http.get(FullPath, { headers: this.createHeader() })
  //.map((res: Response) => res.json());


}

@Injectable()
export class ParameterHashLocationStrategy extends HashLocationStrategy {
  prepareExternalUrl(internal: string): string {
    ////////console.log('preparing external url', window.location.search, super.prepareExternalUrl(internal));
    return window.location.search + super.prepareExternalUrl(internal);
  }
}
